export default __webpack_public_path__ + "static/media/elysianFields.1d98a2a7.png";